import React, { useState, useEffect } from "react";
import "../App.css";
import LegacyHealingIntake from "./LegacyHealingIntake.jsx";
import LegacyHeader from "./header.jsx";
import PersonalContactForm from "./PersonalDetails.jsx";
import ResidencySponsorInfo from "./ResidencySponsorInfo.jsx";
import MedicalLegalInfo from "./MedicalLegalInfo.jsx";
import BelongingsDevicesForm from "./BelongingsDevicesForm.jsx";
import PoliciesConsentForm from "./PoliciesConsentForm.jsx";
import RegistrationCompleted from "./RegistrationCompleted.jsx";
import ReviewConfirmation from "./Reviewpage/ReviewAndConfirmation.jsx";
import { getUploadedImages, clearUploadedImages } from '../components/PhotoUploader/getUploadedImages';

function HomePage() {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    medicalLegal: {},
    personalContact: {},
    residencySponsor: {},
    belongingsDevices: {},
    reviewConfirmation: {}, // Added this new section
    policiesConsent: {},
  });
  const totalSteps = 8;

  // Progress bar should show from step 2 to step 7
  const showProgressBar = step >= 2 && step <= 7;

  // Calculate progress percentage (0% at step 2, 100% at step 7)
  const progressPercentage = showProgressBar ? ((step - 2) / (7 - 2)) * 100 : 0;

  const goNext = () => {
    if (step < totalSteps) setStep(step + 1);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const goBack = () => {
    if (step > 1) setStep(step - 1);
  };

  const handleSubmit = (data) => {
    setFormData((prev) => {
      // Determine which section to update based on current step
      let sectionKey;
      switch (step) {
        case 1: // LegacyHealingIntake - might not need data storage
          return prev; // Skip storing data for step 1
        case 2:
          sectionKey = "medicalLegal";
          break;
        case 3:
          sectionKey = "belongingsDevices";
          break;
        case 4:
          sectionKey = "personalContact";
          break;
        case 5:
          sectionKey = "residencySponsor";
          break;
        case 6:
          sectionKey = "reviewConfirmation"; // You might want to add this to initial state
          break;
        case 7:
          sectionKey = "policiesConsent";
          break;
        default:
          sectionKey = "other";
      }

      return {
        ...prev,
        [sectionKey]: data,
      };
    });
    goNext();
  };

  const navigateBack = () => {
    goBack();
  };

  const navigatestart = () => {
    setStep(1);
    setFormData({
      medicalLegal: {},
      personalContact: {},
      residencySponsor: {},
      belongingsDevices: {},
      reviewConfirmation: {},
      policiesConsent: {},
    });
    window.localStorage.setItem("signatureData", "");
    window.localStorage.setItem("staffSignatureData", "");
    clearUploadedImages();
  };

  return (
    <div className="App">
      <LegacyHeader />
      {showProgressBar && (
        <div className="progress-container">
          <div
            className="progress-bar"
            style={{ width: `${progressPercentage}%` }}
          ></div>
          <div className="step-indicators">
            {[...Array(6)].map((_, i) => {
              // Steps shown in progress bar: 2-7 (but display as 1-6)
              const stepNumber = i + 1;
              const actualStep = i + 2; // Map to actual steps 2-7
              return (
                <div
                  key={actualStep}
                  className={`step-circle ${
                    actualStep == step ? "active" : ""
                  }`}
                  // onClick={() => setStep(actualStep)}
                >
                  {actualStep < step ? "✓" : stepNumber}
                </div>
              );
            })}
          </div>
        </div>
      )}
      {step === 1 && (
        <LegacyHealingIntake
          onNext={goNext}
        />
        // <PoliciesConsentForm
        //   primaryColor="#1F3047"
        //   secondaryColor="#349AC8"
        //   onBack={navigateBack}
        //   onSubmit={(data) => handleSubmit(data)}
        //   data={formData}
        // />
      )}
      {step === 2 && (
        <MedicalLegalInfo
          primaryColor="#1F3047"
          secondaryColor="#349AC8"
          onBack={navigateBack}
          onSubmit={(data) => handleSubmit(data)}
          data={formData}
        />
      )}

      {step === 3 && (
        <BelongingsDevicesForm
          primaryColor="#1F3047"
          secondaryColor="#349AC8"
          onBack={navigateBack}
          onSubmit={(data) => handleSubmit(data)}
          data={formData}
        />
      )}
      {step === 4 && (
        <PersonalContactForm
          primaryColor="#1F3047"
          secondaryColor="#349AC8"
          onBack={navigateBack}
          onSubmit={(data) => handleSubmit(data)}
          data={formData}
        />
      )}
      {step === 5 && (
        <ResidencySponsorInfo
          primaryColor="#1F3047"
          secondaryColor="#349AC8"
          onBack={navigateBack}
          onSubmit={(data) => handleSubmit(data)}
          data={formData}
        />
      )}

      {step === 6 && (
        <ReviewConfirmation
          primaryColor="#1F3047"
          secondaryColor="#349AC8"
          onBack={navigateBack}
          onSubmit={(data) => handleSubmit(data)}
          data={formData}
        />
      )}
      {step === 7 && (
        <PoliciesConsentForm
          primaryColor="#1F3047"
          secondaryColor="#349AC8"
          onBack={navigateBack}
          onSubmit={(data) => handleSubmit(data)}
          data={formData}
        />
      )}
      {step === 8 && (
        <RegistrationCompleted
          primaryColor="#1F3047"
          secondaryColor="#349AC8"
          successColor="#349AC8"
          textColor="#181818"
          onPrint={navigatestart}
          onFinish={navigatestart}
        />
      )}
    </div>
  );
}

export default HomePage;
